const asosKey = "asos";
const plpKey = "plp";

export const config = {
  globalKeys: {
    asosKey,
    webContextKey: `${asosKey}.webContext`,
    eventBusKey: `${asosKey}.eventBus`,
    sdkKey: `${asosKey}.sdk`,
    plpKey: `${asosKey}.${plpKey}`,
    storeKey: `${asosKey}.${plpKey}._data`,
    configKey: `${asosKey}.${plpKey}._config`,
    pageLoadDataKey: `${asosKey}.${plpKey}._pageLoadData`
  }
};
